import { useEffect, useState } from 'react'
import { Group } from 'iconoir-react'
import { LazyStaffCell } from 'app/components/LazyStaffCell'
import { getRoleName } from 'app/graphql/roleNames'
import { bg } from 'lib/background'

/** A role row in an owner picker. A role nobody at the location holds stays visible but says why it is off. */
export function RoleOptionLabel({ name, disabled }: { name?: string; disabled?: boolean }) {
  return (
    <span className="flex min-w-0 items-center gap-2">
      <Group className="h-5 w-5 shrink-0 text-subtle" strokeWidth={1.75} />
      <span className="flex min-w-0 flex-col">
        <span className="truncate">{name}</span>
        {disabled && <span className="text-body-xs text-subtle">No one at this location</span>}
      </span>
    </span>
  )
}

/** A task's assignee: a role reads as a group, never as a person. */
export function TaskAssigneeLabel({
  ownerId,
  roleId,
  emptyLabel = `Unassigned`,
}: {
  ownerId?: string | null
  roleId?: string | null
  emptyLabel?: string
}) {
  const [roleName, setRoleName] = useState<string>()

  useEffect(() => {
    if (!roleId) return
    let alive = true
    bg(getRoleName(roleId).then((name) => alive && setRoleName(name)))
    return () => {
      alive = false
    }
  }, [roleId])

  if (roleId) {
    return (
      <span className="flex min-w-0 items-center gap-2 text-body-sm text-default">
        <Group className="h-5 w-5 shrink-0 text-subtle" strokeWidth={1.75} />
        <span className="min-w-0 truncate">{roleName ?? `Role`}</span>
      </span>
    )
  }
  if (ownerId) return <LazyStaffCell userId={ownerId} loadingIndicator={false} />
  return <span className="text-body-xs text-minimal">{emptyLabel}</span>
}
